export const mapCartAddOnItems = <T extends { id: number; quantity: number }>(addOnItems: T[]) =>
  addOnItems.map((item) => ({
    addOnItemId: item.id,
    quantity: item.quantity,
  }));
